const FEATURES = [
  {
    icon: "ri-lightbulb-flash-line",
    title: "이해 중심 설명",
    desc: "일본어를 처음 만나는 사람도 헷갈리지 않도록, 한국어로 원리부터 쉽게 풀어드려요.",
  },
  {
    icon: "ri-chat-quote-line",
    title: "매회 말하기 연습",
    desc: "배운 표현은 그날 바로 내 입으로 뱉어 봅니다. &lsquo;눈으로만 아는 일본어&rsquo; 방지.",
  },
  {
    icon: "ri-user-voice-line",
    title: "실전 상황 연습",
    desc: "여행 상황, 자기소개, 취미 대화 등 실제로 쓸 만한 상황을 그대로 옮겨서 연습해요.",
  },
  {
    icon: "ri-star-line",
    title: "소수정예 피드백",
    desc: "최대 5명 클래스라 모든 수강생 발음과 문장에 개별 코멘트를 드립니다.",
  },
];

export default function Features() {
  return (
    <section className="py-10 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-10">
        <div className="text-center mb-12">
          <span className="text-[10px] md:text-sm font-semibold tracking-widest text-primary-600 uppercase">
            Why This Class
          </span>
          <h2 className="mt-3 font-heading text-xl md:text-4xl font-bold text-foreground-950">
            수업의 특징
          </h2>
          <p className="mt-2 text-xs sm:text-base text-foreground-700">
            &lsquo;외우는 일본어&rsquo;가 아니라 &lsquo;쓰는 일본어&rsquo;를 만드는 4가지 방식.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="bg-background-50 border border-background-200 rounded-xl p-3 sm:p-6 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xl sm:text-2xl shrink-0">
                  <i className={f.icon}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-base sm:text-lg font-bold text-foreground-950">
                    {f.title}
                  </h3>
                  <p
                    className="mt-1 text-xs sm:text-sm text-foreground-700 leading-relaxed break-all"
                    dangerouslySetInnerHTML={{ __html: f.desc }}
                  ></p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}